export default __webpack_public_path__ + "static/media/pic2.b7b06024.jpg";